import { Link } from "react-router-dom";
import { blogPosts } from "@/mocks/updiag";

export default function BlogSection() {
  return (
    <section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-orange-100 text-[#F97316] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Blog &amp; Conseils
          </span>
          <h2 className="text-4xl font-extrabold text-[#0F3B5F] mb-4" style={{ fontFamily: "Barlow, sans-serif" }}>
            Nos derniers articles
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto">Conseils d'experts sur les diagnostics immobiliers, la réglementation et les obligations à Paris et en IDF.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
          {blogPosts.map((post) => (
            <Link key={post.id} to={`/blog/${post.slug}`} className="group bg-white rounded-2xl border border-gray-100 overflow-hidden hover:-translate-y-1 transition-all duration-300 block">
              <div className="relative h-48 overflow-hidden">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                <span className="absolute top-3 left-3 bg-[#F97316] text-white text-xs font-bold px-3 py-1 rounded-full">{post.category}</span>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 text-xs text-gray-400 mb-3">
                  <span><i className="ri-calendar-line mr-1"></i>{post.date}</span>
                  <span><i className="ri-time-line mr-1"></i>{post.readTime} de lecture</span>
                </div>
                <h3 className="font-bold text-[#0F3B5F] text-base leading-snug mb-3 group-hover:text-[#F97316] transition-colors" style={{ fontFamily: "Barlow, sans-serif" }}>
                  {post.title}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed mb-4 line-clamp-3">{post.excerpt}</p>
                <span className="text-sm font-semibold text-[#F97316] flex items-center gap-1">
                  Lire la suite <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link to="/blog" className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-[#0F3B5F] text-[#0F3B5F] rounded-xl font-bold hover:bg-[#0F3B5F] hover:text-white transition-all duration-200 whitespace-nowrap">
            Voir tous les articles <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
